<template>
<div class="uon">

    <div v-if="boxLoadClaim.wait" class="CruisePage__ifloader"><Loader class="CruisePage__loader" /></div>


    <div v-if="!boxLoadClaim.wait && !boxLoadClaim.ok" class="uon-imp">ошибка: {{boxLoadClaim.error}}</div>

    <div v-if="!boxLoadClaim.wait && boxLoadClaim.ok">
        <!--h2>Заявка номер {{claim().param.num}}</h2-->
        <div v-if="isPacketOrHotel()">
            <button @click="cli" class="qq-quick-booking-container btn primary uon-but" :data-booking="booking_id()">
                Отправить в UON заявку №{{claim().param.num}}
            </button>
            <div v-if="afterclick">{{afterclick}}</div>

            <div class="uon-show">
                <div><button class="btn link" @click="show_ta">показать данные</button></div>
                <div v-if="show_ta_val"><textarea class="uon-ta">{{booking_data.text}}</textarea></div>
            </div>
        </div>
        <div v-else>
            <div class="uon-imp">Быстрое бронирование работает только для пакетных и отельных туров</div>
        </div>
    </div>


</div>
</template>

<style lang="scss">
    .uon {
        &-ta {height: 200px; resize: both; width: 100%; margin-top: 5px;}
        &-imp {background: #ffcccc; padding: 10px; border-radius: 5px;}
        &-show {margin-top: 15px;}
        &-but {border: 2px solid #3978ca; border-radius: 5px;}
    }
</style>

<script setup>
import dayjs from 'dayjs'
import { claimFull } from '@/actions.js'
//import { claimFull } from './testClaimFull.js'
import {ref,unref} from 'vue'
import Loader from '@/comp/Loader/Loader.vue'

///console.log('xxx')

const props = defineProps({
  claim_id: String,
})

const boxLoadClaim = ref({
    wait: false,
    ok: null,
    resolve: null,
    reject: null,
    error: null,
})

const afterclick = ref('')

const booking_data = ref({
    orig: null,
    text: '',
})

const show_ta_val = ref(false)

const show_ta = () => {
    show_ta_val.value = !show_ta_val.value
}

const cli = (event) => {
    let t = event.target
    if (t.querySelector('.qq')) {
        // все где надо, ничего не делаем
    } else {
        afterclick.value = 'Установите плагин Qui-Quo и тыкните снова'    
    }
}


const claim = () => {// чтобы не таскать синтаксический мусор
    return boxLoadClaim.value.resolve
}
const isPacketOrHotel = () => {
    return [1,4].indexOf( claim().tour.product ) >= 0
}

const booking_id = () => {
    let zid = claim().param.id
    return `qq_qb_${zid}` 
}

const saveToLS = () => {
    let z = claim()
    let general = extract_general( z )
    general.prices = extract_prices( z )
    let hotels = extract_hotels( z )
    let flights = extract_flights( z )

    let passengers = extract_pass( z )
    let client = extract_customer( z )

    let uslugi = extract_uslugi(z)
    // insurance
    // supplements
    // transfers

    let tosave = {
        booking: {
           general,
           hotels,
           flights,

           client,
           passengers,
           ...uslugi,
        }
    }
    let tosave_json = JSON.stringify( tosave )
    let tosave_formatted = JSON.stringify( tosave ,null,'  ');
    booking_data.value = {
        orig: tosave,
        text: tosave_formatted
    }
    sessionStorage.setItem( booking_id(), tosave_json )
}

const ymd2dmy = v => {
    let r = ''
    if (v) {
        r = dayjs(v).format('DD.MM.YYYY')
    }
    return r
}

const extract_general = (claim) => {
    let tt = claim.tourists
/*
    const STATUS_ADL = 1;
    const STATUS_CHD = 2;
    const STATUS_INF = 3;
*/    
    let adults= tt.filter( p => 1 === p.status ).length
    let children= tt.filter( p => 2 === p.status ).length
    let infant = tt.filter( p => 3 === p.status ).length
    let nights= claim.tour.nights
    let dateStart = ymd2dmy(claim.tour.datebeg)
    let dateEnd = ymd2dmy(claim.tour.dateend)
    let tourOperatorReference = claim.param.identifier
/*
TOUR_PACKET = 1;
const TOUR_HOTEL = 4;
*/    
    let tour_type = claim.tour.product 
    let cityFrom = 1 == tour_type ? claim.tour.stown : ""  
    let product_type = 1 == tour_type ? 'Package' : 'Hotel' 

    let operator = claim.param.provider


    return { 
        adults, children, infant,
        nights, dateStart, dateEnd,
        operator, tourOperatorReference, 
        cityFrom, product_type,
    }
}

const usluga = ({ name, datebeg, dateend, count }) => {
    let ret = {
        description: name,
        dateStart: datebeg,
        dateEnd: dateend,
    }
    if (count) {
        ret.count = count
    }
    return ret
}

const extract_uslugi = (claim) => {
    let ret = {}
    if (claim.insurance) {
        ret.insurance = [usluga(claim.insurance)]
    }
    if (claim.supplements) {
        ret.supplements = claim.supplements.map( usluga )
    }
    if (claim.transfers) {
        ret.transfers = claim.transfers.map( usluga )
    }

    return ret
}


const extract_prices = (claim) => {
    let { 
        est_cost: nett, est_value: gross,
        base_cost: nett1, base_value: gross1,
        currency,
    }  = claim.cost
    let inNationalCurrency = {
        gross,
        nett,
        currency: "RUB",
    }
    let ret = {inNationalCurrency}
    if (currency!=="RUB") {
        ret.inForeignCurrency = {
            gross:gross1,
            nett:nett1,
            currency,
        }
    }
    return ret
}
const extract_hotels = (claim) => {
    let h = claim.hotel
    let hotelName = h.name
    let region = h.town
    let country = h.country
    let dateStart = h.datebeg
    let dateEnd = h.dateend
    let nights = h.nights
    let roomType = h.room
    let boardType = h.meal
    let accommodation = h.htplace
    return [{
        hotelName, region, country,
        dateStart, dateEnd, nights,
        roomType, boardType, accommodation,
    }]
}
const extract_flights = (claim) => {
    let extract = []
    let fuel = claim.fuel
    let fuelCharge = null
    if (fuel) {
        fuelCharge = [{
            description: fuel.name,
            dateStart: fuel.datebeg,
            dateEnd: fuel.dateend,
            count: fuel.count,
            totalPrice: fuel.price,
            totalPriceCurrency: fuel.currency,
        }]
    }
    let fli = claim.flights
    if (fli) {
        let sectors = fli.map( f => {
            let ret = {
                departureCity : f.src_town,
                arrivalCity : f.dst_town,
                departureDate : f.datebeg,
                serviceClass : f.frclass,
            }
            if (f.freight_ext) {
                ret = { 
                    ...ret,
                    airlineName: f.aviacomp,
                    flightNumber: f.flight_number,
                    departureTime: f.src_time,
                    departureAirportID: f.src_port_iata,
                    arrivalTime: f.dst_time,
                    arrivalAirportID: f.dst_port_iata,
                }
            }
            return {segments: [ret]}
        } )
        extract = [ { fuelCharge, sectors} ]
    }
    return extract
}

const mapSex = (male) => {
    return male ? "1" : "2"
}

const mapType = ( status ) => {
    let ADUINF = {
        "1": "adult",
        "2": "child",
        "3": "infant",
    }
    let t = ADUINF[ status.toString() ] || ADUINF["1"]
    return t
}
const extract_pass = (claim) => {
    let ret = claim.tourists.map( ({
        other_fio, doc_fio, is_customer, status,
        person: {born, male}, 
        document: {type_id, pserie, pnumber, pissue, pvalid, country_name,}
    }) => {
        let docType = uon_doctype( type_id )
        let doc = {
            docType,
            serial: pserie,
            number: pnumber,
            issueDate: ymd2dmy(pissue),
            expire: ymd2dmy(pvalid),
        }
        let ret = {
            sex: mapSex(male),
            type: mapType(status),
            nationality: country_name,

            firstName: doc_fio.firstName,
            lastName: doc_fio.lastName, 
            secondName: doc_fio.middleName,

            birthday: ymd2dmy( born ),
            isClient: is_customer,
            ...doc
        }
        return ret
    })
    return ret
}
const uon_doctype = (id) => {
    let ret=null
 /* nationalPassport internationalPassport    
    const FOREIGN_PASSPORT = 1;
    const NATIONAL_PASSPORT = 2;
    const BIRTH_CERTIFICATE = 3;     */
    if (1 == id) {
        ret = 'internationalPassport'
    } else if (2==id) {
        ret =  'nationalPassport'
    } else if (3==id) {
        ret = 'birthdayCertificate'
    }
    return ret
}
const extract_customer = (claim) => {
    let {
        firstName, middleName:secondName, lastName,
        male, born, phone, email, address, 
        pserie, pnumber, pdocument_type_id, pissue, pvalid, pauthority, punitcode,
        country_name,
    } = claim.customer
    let docType =  uon_doctype(pdocument_type_id)

    return {
        sex: mapSex(male),
        firstName, secondName, lastName,
        phone, email, birthday: ymd2dmy(born),
        address, docType,
        nationality: country_name, 
        authority: pauthority,
        authorityCode: punitcode,
        serial: pserie,
        number: pnumber,
        issueDate: ymd2dmy(pissue),
        expire: ymd2dmy(pvalid),
        isClient: true,
    }
}


const procClaimFull = (resolve, reject) => {
    let { claim_id } = props
    boxLoadClaim.value.wait = true
    claimFull( {claim_id }).then( resolve => {
        boxLoadClaim.value = {
            wait: false,
            ok: true,
            reject: null,
            resolve,
            error: null,
        }
        saveToLS()
    }, reject => {
        let error = reject.toString() // тут возможны еще какие-то копания
        boxLoadClaim.value = {
            wait: false,
            ok: false,
            reject,
            resolve: null,
            error,
        }
    })
}

procClaimFull()

</script>
